import React from "react";
import LeftSide from "./component/LeftSide";
import RightSide from "./component/RightSide";

function App() {
  return (
    <div className="flex h-full flex-wrap items-center sm:flex-nowrap sm:flex-col	 ">
      <LeftSide />
      <RightSide />
    </div>
  );
}

export default App;
